// AI Generated Test
import { Component, Input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
    selector: 'form-global-policy-pre-content-rule-max-length',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    template: `
        <div class="mt-4 mx-4" ngModelGroup="ruleMaxLength">
            <div class="row">
                <div class="col-24 col-md-30">
                    <div class="card panel-monsido-card">
                        <div class="card-header">
                            <h4 class="font-weight-300" translate>Policy setup</h4>
                        </div>
                        <div class="card-body">
                            <div class="form-group row">
                                <label for="policy-pre-content-inputfield" class="col-sm-8 col-form-label text-bold text-right capitalize-first-letter">
                                    <span translate>Word length</span>
                                    <span>*</span>
                                </label>
                                <div class="col-sm-40">
                                    <input [(ngModel)]="value"
                                           name="maxWordLength"
                                           type="number"
                                           class="form-control"
                                           id="policy-pre-content-inputfield"
                                           placeholder="{{ 'insert max word length' | translate }}"
                                           (ngModelChange)="onModelChange()"
                                           required
                                           min="1"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-24 col-md-18">
                    <div class="card panel-monsido-card">
                        <div class="card-header">
                            <h4 class="font-weight-300" translate>
                                Information
                            </h4>
                        </div>
                        <div class="card-body">
                            <p>
                                <strong translate>How to setup this policy</strong>
                            </p>
                            <p translate>To setup this policy, you need to tell us how long your max word length is</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
    standalone: false,
})
export class FormGlobalPolicyPreContentRuleMaxLengthComponent {
    @Input() model: any;
    value: any;

    onModelChange () {
        this.model = [
            {
                name: 'Max. word length',
                case_sensitive: true,
                inverse: false,
                operator: 'regex',
                query: '\\p{Space}(\\p{Word}{' + parseInt(this.value + 1) + ',})\\p{Space}',
                type: 'page_text',
                sub_entry: '',
            },
        ];
    }
}
